import blog from "./Image/blog.png";
import clock from "./Image/clock.png";
import todo from "./Image/todo.png";

import netflix from "./Image/netflix.png";
import library from "./Image/library.png";
import analog from "./Image/analog.png";
import ecommerce from "./Image/ecommerce.png";

export const details = [
  {
    heading: "Ecommerce Project",
    dis: "I build this ecommerce project using Next Js, Sanity.io, Stripe, Advanced-React such as Folder and file structure, hooks and refs. Advanced State Management of the entire application using React,Context API, and the complete integration with Stripe so that i can cover REAL payments.",
    img: ecommerce,
    tech: "HTML, CSS, Next.js, React, Sanity.io, Stripe, hooks & refs, Context Api",
    github:
      "https://github.com/Pitambarbittu/ecommerce_pitambar_buyme_sanity_stripe",
    preview:
      "https://ecommerce-project-pitambar-buyme-sanity-stripe.vercel.app/",
  },

  {
    heading: "NetFlix Clone Project",
    dis: "This project is a Clone of NetFlix, in this project i used React, jsx as a front end and Nodejs as a backend, and for Login & Signup i used Firebase,Routing, hook's, Bootstrap & Firebase.",
    img: netflix,
    tech: "HTML, CSS, JavaScript, React, Node",
    github: "https://github.com/Pitambarbittu/Netflix-Project",
    preview:
      "https://netflix-project-l46obmq11-pitambarbittus-projects.vercel.app",
  },

  {
    heading: "Blog Project",
    dis: "a blog page which has different blogs on different categories like sports,hollywood etc. using React as a front end and nodeJs as a backend.",
    img: blog,
    tech: "HTML, CSS, JavaScript, React, Node",
    github: "https://github.com/Pitambarbittu/React-Blog-App",
    preview: "https://react-blog-app-project-pitambar-bittu.netlify.app",
  },

  {
    heading: "Library Project",
    dis: "This Library Project i created using React js. in this project we can add books name author name and store it to Local storage, with Lottie files and react-Toastify.",
    img: library,
    tech: "HTML, CSS, JavaScript, React",
    github: "https://github.com/Pitambarbittu/Library-project",
    preview: "https://library-project-pitambar-bittu.netlify.app",
  },

  {
    heading: "Digital  Clock",
    dis: "I made this using HTML , CSS and JAVASCRIPT, the digital clock is used to fetch the IST and change the images according to the current time.",
    img: clock,
    tech: "HTML, CSS, JavaScript",
    github: "https://github.com/Pitambarbittu/Digital-Clock",
    preview: "https://pitambarbittu.github.io/Digital-Clock/",
  },

  {
    heading: "Todo List",
    dis: "In this project we can able to make different number of cards where in that we can able to add our priorities in the card.",
    img: todo,
    tech: "HTML, CSS, JavaScript, React",
    github: "https://github.com/Pitambarbittu/Todo-App-JS",
    preview: "https://pitambarbittu.github.io/Todo-App-JS/",
  },

  {
    heading: "Analog Clock",
    dis: "This is my simple Analog Clock project.i have used only HTML5 and CSS in this project. ",
    img: analog,
    tech: "HTML, CSS",
    github: "https://github.com/Pitambarbittu/clock-html-css",
    preview: "https://pitambarbittu.github.io/clock-html-css/",
  },
];
